export default "__VITE_ASSET__DD80seSI__"